import { useEffect } from 'react';
// import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import './i18n';
import RTL from './components/RTL';
// import SettingsDrawer from './components/SettingsDrawer';
import SplashScreen from './components/SplashScreen';
import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import gtm from './lib/gtm';
import AppRoutes from './routes';
import { createCustomTheme } from './theme';
import WebSocketComponent from './components/WebSocketComponent';
import Tabs from './components/Tabs';
import TabManager from './components/TabManager';
import FreshchatWidget from "./components/FreshchatWidget";
// Abdo essaidi : importation de BulkUpdateProvider
import { BulkUpdateProvider } from './contexts/BulkUpdateContext';

const App = () => {
  // const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();

  useScrollReset();

  // useEffect(() => {
  //   gtm.initialize(gtmConfig);
  // }, []);

  const theme = createCustomTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });
  // Abdo essaidi : Ajoutez le BulkUpdateProvider autour du contenu
  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <BulkUpdateProvider>   
        <CssBaseline />
        <Toaster position="top-center" />
        {auth.isInitialized ? (
               <>
               {/* <Tabs /> */}
               <FreshchatWidget />
               {/* <TabManager> */}
                 <AppRoutes />
               {/* </TabManager> */}
               <WebSocketComponent />
             </>
        ) : <SplashScreen />}
        </BulkUpdateProvider>
      </RTL>
    </ThemeProvider>
  );
};

export default App;